var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_index"},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}]}),_c('router-view',{on:{"reRenderIndex":_vm.reRenderIndex}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }